<template>
  <div>
    <!-- class="grid md:grid-cols-2 lg:grid-cols-3 grid-cols-1 lg:gap-8 md:gap-8 gap-8" -->
    <h2 class="fsize22 sm-fsize20px font-semibold pb-2">BookMarks Items</h2>
    <div class="grid grid-cols-2 gap-4">
      <div
        v-for="(item, index) in pageData"
        :key="index"
        class="bookmark-card rounded-b-lg relative shadow-xl bg-white item"
      >
        <img
          :src="$imageURL + '/' + item.itemdata.image"
          alt="Blog image"
          class="rounded-t-lg h-48 w-full object-contain cursor-pointer"
          @error="hasError = true"
          @click="goToBlogPage(item)"
        />
        <div class="p-4 bg-white">
          <p
            class="text-black footertitle font-bold cursor-pointer fsize18-14px ellipsis-1 lh-28"
          >
            {{ item.itemdata.title }}
          </p>
          <p class="pt-2 clr777 font-normal">
            {{
              new Date(item.itemdata.date).toLocaleDateString("en-IN", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })
            }}
          </p>
          <div v-html="item.itemdata.html" class="ellipsis-2 pt-2 h-16"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Loading,
  },
  // mixins: [blogMixin],
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    category: {
      type: String,
      default: "blog",
    },
    currentPage: {
      type: Number,
    },
  },
  data() {
    return {
      readmoreblog: false,
      hasError: false,
      defaultImage:
        this.$imageURL + "/caregiversaathi/default/dummy%20image.jpg",
      pageData: [],
    };
  },
  computed: {
    ...mapState("auth", { user: "user", getUserByUserId: "getUserByUserId" }),
    ...mapState("bookMarks", {
      getbookMarks: "getbookMarks",
    }),
  },
  methods: {
    async init() {
      let payload = {
        _id: this.user._id,
        type: "page",
      };
      const { data } = await this.$store.dispatch(
        "bookMarks/GetBookmarks",
        payload
      );
      this.pageData = data.filter((item) => item.type === "page");
      console.log("Page Data:", this.pageData);
    },

    image(item) {
      return item.image ? `${this.$imageURL}/${item.image}` : this.defaultImage;
    },

    goToBlogPage(item) {
      this.$router.push({
        name: "blogspage",
        params: {
          itemId: item.itemId,
          slug: this.encodeURIBlog(item.itemdata.title),
        },
      });
    },
    encodeURIBlog(string) {
      //return encodeURI(string);
      return string.replace(/-/g,"_").replace(/\s/g, "-");
    },
  },
  mounted() {
    this.init();
    console.log("getbookMarks123", this.getbookMarks);
  },
};
</script>
